import { useCallback, useEffect, useState } from 'react';

import { getApiErrorMessage } from '../utils/apiError';
import { getStudentClasses } from '../services/studentClasses.service';

const useStudentClasses = (studentId) => {
  const [data, setData] = useState({ student: null, classes: [] });
  const [loading, setLoading] = useState(Boolean(studentId));
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    if (!studentId) {
      setData({ student: null, classes: [] });
      setLoading(false);
      return null;
    }

    setLoading(true);
    setError('');

    try {
      const next = await getStudentClasses(studentId);
      setData(next);
      return next;
    } catch (err) {
      if (err?.response?.status === 401) {
        setError('Your session has expired. Please sign in again.');
      } else {
        setError(getApiErrorMessage(err, 'Unable to load student classes. Please try again.'));
      }
      setData({ student: null, classes: [] });
      return null;
    } finally {
      setLoading(false);
    }
  }, [studentId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...data, loading, error, refresh };
};

export default useStudentClasses;
